import React, { PureComponent } from 'react';
import cn from 'classnames';
import Icon, { Icons } from '@shared/Icons/Icon';
import { isMobileOrTablet } from '../../utils/browserDetection';
import EventList from '../CategoryPage/components/EventList';
import EventMapMapbox from '../../shared/EventMapMapbox';
import Loading from '../../shared/Loading';

import BrowseLayout from '../CategoryPage/layout/BrowseLayout';

import {
  header,
  backIcon,
  container,
  eventList,
  sidebar,
  list,
  hidden as hiddenStyle,
  dataLoadingStyle,
} from './styles.module.css';

class CategoryMapPage extends PureComponent {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    mapLoaded: false,
  };

  mapLoaded = () => {
    this.setState({ mapLoaded: true });
  };

  render() {
    const {
      categoryData,
      mapEvents,
      specificEvents,
      loading,
      query,
      point,
      viewport,
      selectedEventId,
      hoverEventId,
      onEventHoverOn,
      onEventHoverOff,
      backText,
      eventListRef,
      selectedEventCardRef,
      onEventSelect,
      onNewSearch,
      onBackClick,
      showHeader,
      handleTracking,
      hideBackClick,
      hideEventList,
      mapStyle,
    } = this.props;

    const { ne = {}, sw = {} } = viewport || {};

    // Renders Full Feature Event List with thin/nearby events,
    // header, footer, pagination, etc on desktop
    const BrowseLoadComponent = loading ? (
      <div className={dataLoadingStyle}>
        <Loading />
      </div>
    ) : (
      <BrowseLayout
        onEventHoverOn={onEventHoverOn}
        onEventHoverOff={onEventHoverOff}
        categoryData={categoryData}
        mapMode
        {...this.props}
        isGroupingsHidden
      />
    );

    return (
      <>
        {showHeader && !hideBackClick && (
          <div className={header} onClick={onBackClick} onKeyPress>
            <Icon className={backIcon} icon={Icons.ARROW_LEFT.RED} />
            <span>{backText}</span>
          </div>
        )}

        <div className={container}>
          {!hideEventList && (
            <div className={sidebar}>
              {/* Renders custom event list which overlays map in mobile */}
              {isMobileOrTablet() ? (
                <div
                  className={cn({
                    [list]: true,
                    [hiddenStyle]: !this.state.mapLoaded,
                  })}
                  ref={eventListRef}
                >
                  <EventList
                    className={eventList}
                    onEventHoverOn={onEventHoverOn}
                    onEventHoverOff={onEventHoverOff}
                    activeEventId={selectedEventId}
                    activeEventRef={selectedEventCardRef}
                    events={specificEvents} // Do not show nearby events in mobile map.
                    query={query}
                    showLoadMore={false}
                    showRecommendRaceCard={false}
                    currentPageNumber={1}
                    resultsPerPage={mapEvents.length}
                    total={mapEvents.length}
                    handleExternalTracking={handleTracking}
                  />
                </div>
              ) : (
                BrowseLoadComponent
              )}
            </div>
          )}
          <EventMapMapbox
            center={point}
            viewportNorthEastLat={ne.lat}
            viewportNorthEastLong={ne.lng}
            viewportSouthWestLat={sw.lat}
            viewportSouthWestLong={sw.lng}
            loading={loading}
            events={specificEvents} // Do not show nearby events in map.
            selectedEventId={selectedEventId}
            hoverEventId={hoverEventId}
            onEventSelect={onEventSelect}
            onNewSearch={onNewSearch}
            handleTracking={handleTracking}
            mapLoaded={this.mapLoaded}
            mapStyle={mapStyle}
          />
        </div>
      </>
    );
  }
}

export default CategoryMapPage;
